import router from '../router/router'
import store from '../store/index'

const UNAUTHENTICATED_CLOSE_CODE = 4401
const FORBIDDEN_CLOSE_CODE = 4403
const NOT_FOUND_CLOSE_CODE = 4404

function routeAfterSocketClose(routeName) {
  if (router.currentRoute.value.name === routeName) {
    return
  }

  router.push({ name: routeName })
}

//--------------------------
// create socket connection
//--------------------------
export default function createSocketConnection(type, arena_slug, { logLifecycle = true } = {}) {
  const baseUrl = `${import.meta.env.VITE_BACKEND_WEBSOCKET || ''}`.replace(/\/?$/, '/')
  const url = `${baseUrl}${type}/${arena_slug}/`
  const connection = new WebSocket(url)

  connection.onerror = function (event) {
    console.log('connection error for arena ' + arena_slug)
    window.displayPairs(event.data)
  }

  connection.onopen = function (event) {
    if (logLifecycle) {
      console.log(event)
      console.log('connection opened for arena ' + arena_slug)
    }
  }

  connection.onclose = function (event) {
    if (event.code === 1000) {
      return
    }

    if (logLifecycle) {
      console.log(event)
    }

    if (event.code === UNAUTHENTICATED_CLOSE_CODE) {
      store.commit('auth/setMessage', 'Your session has expired. Please log in again.')
      store.commit('auth/destroyToken')
      store.commit('auth/destroyUserProfile')
      routeAfterSocketClose('loginView')
      return
    }

    if (event.code === FORBIDDEN_CLOSE_CODE) {
      store.commit('auth/setMessage', 'You do not have permission to access that campaign.')
      routeAfterSocketClose('campaignsView')
      return
    }

    if (event.code === NOT_FOUND_CLOSE_CODE) {
      store.commit('auth/setMessage', 'That campaign is no longer available.')
      routeAfterSocketClose('campaignsView')
      return
    }

    console.log('connection closed unexpectedly for arena ' + arena_slug)
  }

  return connection
}
